var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"WebsiteLink",attrs:{"target":"_blank","href":_vm.cleanedHref}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.cleanedHref))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }